import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type ExportCallHistoryModalStore } from '../store/exportCallHistoryModalStore'

type IExportCallHistoryModalActionsProps = {
  store: ExportCallHistoryModalStore
}

export const ExportCallHistoryModalActions: FC<IExportCallHistoryModalActionsProps> = observer(
  ({ store: { onExport, disabled, loadingExport } }) => {
    return (
      <Button
        typeBtn={'contained'}
        text={'Export'}
        onClick={onExport}
        disabled={disabled}
        loading={loadingExport}
      />
    )
  }
)
